__turbopack_context__.v({
  "jetDetails": "jetDetails-module-scss-module__ZAnkWq__jetDetails",
  "jetDetailsContent": "jetDetails-module-scss-module__ZAnkWq__jetDetailsContent",
  "jetDetailsLine": "jetDetails-module-scss-module__ZAnkWq__jetDetailsLine",
  "jetDetailsLineItems": "jetDetails-module-scss-module__ZAnkWq__jetDetailsLineItems",
  "jetDetailsLineMaineTitle": "jetDetails-module-scss-module__ZAnkWq__jetDetailsLineMaineTitle",
  "jetDetailsLineTitle": "jetDetails-module-scss-module__ZAnkWq__jetDetailsLineTitle",
  "jetDetailsLineValue": "jetDetails-module-scss-module__ZAnkWq__jetDetailsLineValue",
  "jetDetailsTitle": "jetDetails-module-scss-module__ZAnkWq__jetDetailsTitle",
});
